import '@mantine/notifications/styles.css';
import { Notifications } from '@mantine/notifications';

export const SnackbarProvider: React.FC = () => <Notifications />;
